import { appConfig } from '@/appConfig';
import { appClient } from '@/lib/appwrite/appClient';
import { treaty } from '@elysiajs/eden';
import { app } from '@polybank/backend';

const JWT_MAX_AGE_MS = 10 * 60 * 1000; // 10 minutes (token expires at 15 min)

let jwt = '';
let jwtCreatedAt = 0;
let isRefreshing = false;
let refreshPromise: Promise<string> | null = null;

function isJwtExpired(): boolean {
  if (!jwt || !jwtCreatedAt) return true;
  return Date.now() - jwtCreatedAt > JWT_MAX_AGE_MS;
}

async function getJwt(): Promise<string> {
  if (jwt && !isJwtExpired()) return jwt;

  if (isRefreshing && refreshPromise) {
    return refreshPromise;
  }

  isRefreshing = true;
  refreshPromise = appClient.account
    .createJWT()
    .then((token) => {
      jwt = token.jwt;
      jwtCreatedAt = Date.now();
      isRefreshing = false;
      refreshPromise = null;
      return jwt;
    })
    .catch((error) => {
      isRefreshing = false;
      refreshPromise = null;
      throw error;
    });

  return refreshPromise;
}

const { api } = treaty<typeof app>(appConfig.API_URL, {
  fetcher: async (url, options) => {
    const token = await getJwt();
    const response = await fetch(url, {
      ...options,
      headers: {
        ...options?.headers,
        authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 401) {
      jwt = '';
      jwtCreatedAt = 0;
      const newToken = await getJwt();
      return fetch(url, {
        ...options,
        headers: {
          ...options?.headers,
          authorization: `Bearer ${newToken}`,
        },
      });
    }

    return response;
  },
});

export { api };
